@if (mainImage$ | async; as main) {
  <cx-product-image-zoom-trigger
    [expandImage]="expandImage.value"
    [galleryIndex]="selectedIndex"
    (click)="openImageDialog()"
    [main]="main"
    [ngClass]="{
      'pointer-cursor': hasExtraImageTypes(main)
    }"
    >
  </cx-product-image-zoom-trigger>
}

@if (thumbs$ | async; as thumbs) {
  @if (product$ | async; as product) {
    @if (thumbs.length) {
      <cx-carousel
        role="region"
      [attr.aria-label]="
        'carousel.carouselForProduct' | cxTranslate: { product: product.name }
      "
        tabindex="-1"
        class="thumbs"
        [items]="thumbs"
        itemWidth="120px"
        [hideIndicators]="false"
        [template]="thumb"
      ></cx-carousel>
    }
  }
}

<ng-template #thumb let-item="item">
  <cx-media
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
    format="product"
    >
  </cx-media>
</ng-template>
@if (currentProduct$ | async; as product) {
  @if (product['has360View']) {
    <div (click)="trigger360Zoom()" class="mt-4">
      <img class="img-360" src="/images/360-btn.JPG" alt="" srcset="">
    </div>
  }
}